var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Type } from "class-transformer";
import { AfterLoad, Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, Unique, UpdateDateColumn, } from "typeorm";
import { BillingMode } from "./billing/billing-mode";
import { Invoice } from "./invoice";
import { CompanyEntity, Employee, Position, TimeEntry, } from "./model";
// Embedded entities for EmployeePayrollData
export class BankDetails {
    constructor() {
        this.payByBankTransfer = true;
    }
}
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], BankDetails.prototype, "payByBankTransfer", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], BankDetails.prototype, "bankAccountOwner", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], BankDetails.prototype, "iban", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], BankDetails.prototype, "bankName", void 0);
export class CurrentStatus {
    constructor() {
        this.immatriculationStatus = false;
        this.registeredAsJobSeeker = false;
        this.receivingAgencyBenefits = false;
    }
}
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], CurrentStatus.prototype, "immatriculationStatus", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], CurrentStatus.prototype, "currentStatus", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], CurrentStatus.prototype, "otherStatus", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], CurrentStatus.prototype, "registeredAsJobSeeker", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], CurrentStatus.prototype, "responsibleAgency", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], CurrentStatus.prototype, "receivingAgencyBenefits", void 0);
export class WorkingStudentFacts {
    constructor() {
        this.lowSalary = false;
        this.shortTermEmployment = false;
        this.moreThan20hOutsideSemesterBreak = false;
        this.vacationSemester = false;
        this.semesterAbove25 = false;
        this.moreThan182DaysOver20h = false;
    }
}
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], WorkingStudentFacts.prototype, "lowSalary", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], WorkingStudentFacts.prototype, "shortTermEmployment", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], WorkingStudentFacts.prototype, "moreThan20hOutsideSemesterBreak", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], WorkingStudentFacts.prototype, "vacationSemester", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], WorkingStudentFacts.prototype, "semesterAbove25", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], WorkingStudentFacts.prototype, "moreThan182DaysOver20h", void 0);
export class ShortTermEmploymentProfessionalism {
    constructor() {
        this.registeredAsJobSeekerShortTerm = false;
        this.receivingAgencyBenefits = false;
        this.receivingSocialBenefits = false;
        this.parentalLeave = false;
        this.militaryOrVoluntaryService = false;
        this.federalVoluntaryService = false;
        this.startingApprenticeship = false;
        this.startingPublicService = false;
        this.employmentBetweenTrainingAndStudy = false;
        this.employmentBetweenStudyAndWork = false;
        this.employmentDuringService = false;
        this.recentFixedTermContract = false;
        this.sameEmployerBefore = false;
        this.newEmploymentAfterPrevious = false;
        this.leaveFromMainJob = false;
        this.eveningSchoolStudent = false;
        this.seasonalHarvestWork = false;
    }
}
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "registeredAsJobSeekerShortTerm", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "receivingAgencyBenefits", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "receivingSocialBenefits", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "parentalLeave", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "militaryOrVoluntaryService", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "federalVoluntaryService", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "startingApprenticeship", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "startingPublicService", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "employmentBetweenTrainingAndStudy", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "employmentBetweenStudyAndWork", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "employmentDuringService", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "recentFixedTermContract", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "sameEmployerBefore", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "newEmploymentAfterPrevious", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "leaveFromMainJob", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "eveningSchoolStudent", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], ShortTermEmploymentProfessionalism.prototype, "seasonalHarvestWork", void 0);
export class AdditionalEmployment {
    constructor() {
        this.additionalRegularEmployment = false;
        this.additionalWorkingStudentEmployment = false;
        this.additionalMarginalEmployment = false;
        this.additionalShortTermEmployment = false;
    }
}
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], AdditionalEmployment.prototype, "additionalRegularEmployment", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Array)
], AdditionalEmployment.prototype, "additionalRegularEmploymentInfo", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], AdditionalEmployment.prototype, "additionalWorkingStudentEmployment", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Array)
], AdditionalEmployment.prototype, "additionalWorkingStudentEmploymentInfo", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], AdditionalEmployment.prototype, "additionalMarginalEmployment", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Array)
], AdditionalEmployment.prototype, "additionalMarginalEmploymentInfo", void 0);
__decorate([
    Column("decimal", { precision: 10, scale: 2, nullable: true }),
    __metadata("design:type", String)
], AdditionalEmployment.prototype, "additionalMarginalEmploymentSalary", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], AdditionalEmployment.prototype, "additionalShortTermEmployment", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Array)
], AdditionalEmployment.prototype, "additionalShortTermEmploymentInfo", void 0);
export class Education {
}
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Education.prototype, "schoolEducation", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Education.prototype, "professionalEducation", void 0);
export class HealthInsuranceStatus {
}
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], HealthInsuranceStatus.prototype, "ensuranceType", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], HealthInsuranceStatus.prototype, "otherEnsuranceType", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], HealthInsuranceStatus.prototype, "lastEnsurance", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], HealthInsuranceStatus.prototype, "ensurerName", void 0);
export class DisabilityInfo {
    constructor() {
        this.disabilityLevel = false;
    }
}
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], DisabilityInfo.prototype, "disabilityLevel", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Number)
], DisabilityInfo.prototype, "disabilityLevelPercentage", void 0);
let APIClient = class APIClient {
    constructor(vals = {}) {
        this.partnerScopes = [];
        Object.assign(this, vals);
    }
};
__decorate([
    PrimaryColumn(),
    __metadata("design:type", String)
], APIClient.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], APIClient.prototype, "secret", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], APIClient.prototype, "name", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], APIClient.prototype, "email", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], APIClient.prototype, "website", void 0);
__decorate([
    Column("jsonb", { default: [] }),
    __metadata("design:type", Array)
], APIClient.prototype, "partnerScopes", void 0);
APIClient = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], APIClient);
export { APIClient };
let APIAuthAccess = class APIAuthAccess {
    constructor(vals = {}) {
        this.scopes = [];
        Object.assign(this, vals);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], APIAuthAccess.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], APIAuthAccess.prototype, "companyId", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE" }),
    __metadata("design:type", CompanyEntity)
], APIAuthAccess.prototype, "company", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], APIAuthAccess.prototype, "clientId", void 0);
__decorate([
    ManyToOne(() => APIClient, { onDelete: "CASCADE" }),
    __metadata("design:type", APIClient)
], APIAuthAccess.prototype, "client", void 0);
__decorate([
    Column("jsonb"),
    __metadata("design:type", Array)
], APIAuthAccess.prototype, "scopes", void 0);
APIAuthAccess = __decorate([
    Entity(),
    Unique("UQ_api_auth_access_client_company", ["clientId", "companyId"]),
    __metadata("design:paramtypes", [Object])
], APIAuthAccess);
export { APIAuthAccess };
let APIAuthToken = class APIAuthToken {
    constructor(init = {}) {
        this.scopes = [];
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryColumn(),
    __metadata("design:type", String)
], APIAuthToken.prototype, "id", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], APIAuthToken.prototype, "created", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], APIAuthToken.prototype, "token", void 0);
__decorate([
    Column("jsonb"),
    __metadata("design:type", Array)
], APIAuthToken.prototype, "scopes", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], APIAuthToken.prototype, "clientId", void 0);
__decorate([
    ManyToOne(() => APIClient, { onDelete: "CASCADE", nullable: true }),
    __metadata("design:type", APIClient)
], APIAuthToken.prototype, "client", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], APIAuthToken.prototype, "companyId", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE" }),
    __metadata("design:type", CompanyEntity)
], APIAuthToken.prototype, "company", void 0);
__decorate([
    Column("timestamptz", { nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], APIAuthToken.prototype, "expires", void 0);
APIAuthToken = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], APIAuthToken);
export { APIAuthToken };
let Account = class Account {
    constructor(vals = {}) {
        this.firstName = "";
        this.lastName = "";
        this.pwdHash = null;
        this.admin = false;
        Object.assign(this, vals);
    }
    async onAfterLoad() {
        this.hasPassword = Boolean(this.pwdHash);
    }
    get name() {
        return `${this.firstName} ${this.lastName}`;
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Account.prototype, "id", void 0);
__decorate([
    Column({ unique: true, nullable: true }),
    __metadata("design:type", String)
], Account.prototype, "email", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Account.prototype, "firstName", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Account.prototype, "lastName", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Account.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Account.prototype, "updated", void 0);
__decorate([
    Column("simple-json", { nullable: true }),
    Exclude(),
    __metadata("design:type", Object)
], Account.prototype, "pwdHash", void 0);
__decorate([
    OneToMany(() => Employee, (e) => e.account, { eager: true }),
    Type(() => Employee),
    __metadata("design:type", Array)
], Account.prototype, "profiles", void 0);
__decorate([
    Column({ type: "varchar", nullable: true }),
    Exclude(),
    __metadata("design:type", Object)
], Account.prototype, "setPwdToken", void 0);
__decorate([
    Type(() => Session),
    OneToMany(() => Session, (s) => s.account),
    __metadata("design:type", Array)
], Account.prototype, "sessions", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], Account.prototype, "admin", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Account.prototype, "featurebaseUserHash", void 0);
__decorate([
    Type(() => CompanyEntity),
    __metadata("design:type", CompanyEntity)
], Account.prototype, "company", void 0);
__decorate([
    AfterLoad(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], Account.prototype, "onAfterLoad", null);
Account = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Account);
export { Account };
let Session = class Session {
    constructor(vals = {}) {
        this.revoked = false;
        this.clientInfo = null;
        Object.assign(this, vals);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Session.prototype, "id", void 0);
__decorate([
    ManyToOne(() => Account, (a) => a.sessions, { onDelete: "CASCADE" }),
    Type(() => Account),
    __metadata("design:type", Account)
], Session.prototype, "account", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], Session.prototype, "accountId", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { nullable: true, onDelete: "CASCADE" }),
    Type(() => CompanyEntity),
    __metadata("design:type", Object)
], Session.prototype, "company", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], Session.prototype, "companyId", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Session.prototype, "token", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", Date)
], Session.prototype, "created", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Session.prototype, "scope", void 0);
__decorate([
    Column({ type: Date, nullable: true }),
    __metadata("design:type", Object)
], Session.prototype, "expires", void 0);
__decorate([
    Column({ type: Date, nullable: true }),
    __metadata("design:type", Object)
], Session.prototype, "lastUsed", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], Session.prototype, "revoked", void 0);
__decorate([
    Column({ type: "jsonb", nullable: true }),
    __metadata("design:type", Object)
], Session.prototype, "clientInfo", void 0);
Session = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Session);
export { Session };
let DailyResults = class DailyResults {
    constructor(init = {}) {
        this.timeBalancePlanned = null;
        this.issues = null;
        Object.assign(this, init);
    }
};
__decorate([
    ManyToOne(() => Employee, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", Employee)
], DailyResults.prototype, "employee", void 0);
__decorate([
    PrimaryColumn(),
    __metadata("design:type", Number)
], DailyResults.prototype, "employeeId", void 0);
__decorate([
    PrimaryColumn("date"),
    __metadata("design:type", String)
], DailyResults.prototype, "date", void 0);
__decorate([
    Column("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "timeBalance", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], DailyResults.prototype, "timeBalancePlanned", void 0);
__decorate([
    Column("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "vacationBalance", void 0);
__decorate([
    Column("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "bonusesBalance", void 0);
__decorate([
    Column("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "results", void 0);
__decorate([
    Column("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "averages", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], DailyResults.prototype, "updated", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], DailyResults.prototype, "issues", void 0);
DailyResults = __decorate([
    Entity(),
    Index("IDX_employee_date_issues", ["employeeId", "date", "issues"], { unique: true }),
    __metadata("design:paramtypes", [Object])
], DailyResults);
export { DailyResults };
let EmployeeTag = class EmployeeTag {
    constructor(init = {}) {
        this.order = 0;
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], EmployeeTag.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], EmployeeTag.prototype, "name", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], EmployeeTag.prototype, "color", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", CompanyEntity)
], EmployeeTag.prototype, "company", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], EmployeeTag.prototype, "companyId", void 0);
__decorate([
    ManyToMany(() => Employee, (employee) => employee.tags, { eager: false }),
    __metadata("design:type", Array)
], EmployeeTag.prototype, "employees", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], EmployeeTag.prototype, "order", void 0);
EmployeeTag = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], EmployeeTag);
export { EmployeeTag };
let EmployeePayrollData = class EmployeePayrollData {
    constructor(init = {}) {
        this.mainJob = false;
        // Initialize embedded entities with defaults
        this.bankDetails = new BankDetails();
        this.currentStatus = new CurrentStatus();
        this.workingStudentFacts = new WorkingStudentFacts();
        this.shortTermEmploymentProfessionalism = new ShortTermEmploymentProfessionalism();
        this.additionalEmployment = new AdditionalEmployment();
        this.education = new Education();
        this.healthInsuranceStatus = new HealthInsuranceStatus();
        this.disabilityInfo = new DisabilityInfo();
        // Then apply any overrides from init
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryColumn({ type: "int", name: "employeeId" }),
    __metadata("design:type", Number)
], EmployeePayrollData.prototype, "employeeId", void 0);
__decorate([
    OneToOne(() => Employee, { onDelete: "CASCADE" }),
    JoinColumn({ name: "employeeId", referencedColumnName: "id" }),
    __metadata("design:type", Employee)
], EmployeePayrollData.prototype, "employee", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], EmployeePayrollData.prototype, "occupation", void 0);
__decorate([
    Column("varchar", { nullable: true }),
    __metadata("design:type", String)
], EmployeePayrollData.prototype, "familyStatus", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], EmployeePayrollData.prototype, "passportNumber", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], EmployeePayrollData.prototype, "mainJob", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], EmployeePayrollData.prototype, "pvBonusChildren", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Array)
], EmployeePayrollData.prototype, "pvChildInfo", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], EmployeePayrollData.prototype, "taxClass", void 0);
__decorate([
    Column("decimal", { precision: 10, scale: 2, nullable: true }),
    __metadata("design:type", String)
], EmployeePayrollData.prototype, "taxClass4Factor", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], EmployeePayrollData.prototype, "childrenFreeAmount", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], EmployeePayrollData.prototype, "confession", void 0);
__decorate([
    Column(() => BankDetails),
    __metadata("design:type", BankDetails)
], EmployeePayrollData.prototype, "bankDetails", void 0);
__decorate([
    Column(() => CurrentStatus),
    __metadata("design:type", CurrentStatus)
], EmployeePayrollData.prototype, "currentStatus", void 0);
__decorate([
    Column(() => WorkingStudentFacts),
    __metadata("design:type", WorkingStudentFacts)
], EmployeePayrollData.prototype, "workingStudentFacts", void 0);
__decorate([
    Column(() => ShortTermEmploymentProfessionalism),
    __metadata("design:type", ShortTermEmploymentProfessionalism)
], EmployeePayrollData.prototype, "shortTermEmploymentProfessionalism", void 0);
__decorate([
    Column(() => AdditionalEmployment),
    __metadata("design:type", AdditionalEmployment)
], EmployeePayrollData.prototype, "additionalEmployment", void 0);
__decorate([
    Column(() => Education),
    __metadata("design:type", Education)
], EmployeePayrollData.prototype, "education", void 0);
__decorate([
    Column(() => HealthInsuranceStatus),
    __metadata("design:type", HealthInsuranceStatus)
], EmployeePayrollData.prototype, "healthInsuranceStatus", void 0);
__decorate([
    Column(() => DisabilityInfo),
    __metadata("design:type", DisabilityInfo)
], EmployeePayrollData.prototype, "disabilityInfo", void 0);
__decorate([
    CreateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], EmployeePayrollData.prototype, "created", void 0);
__decorate([
    UpdateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], EmployeePayrollData.prototype, "updated", void 0);
EmployeePayrollData = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], EmployeePayrollData);
export { EmployeePayrollData };
export class TokenUsage {
}
__decorate([
    Column(),
    __metadata("design:type", Number)
], TokenUsage.prototype, "input", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], TokenUsage.prototype, "cached", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], TokenUsage.prototype, "output", void 0);
let AgentConversationStats = class AgentConversationStats {
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], AgentConversationStats.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: "timestamptz" }),
    __metadata("design:type", Date)
], AgentConversationStats.prototype, "created", void 0);
__decorate([
    Column("uuid", { unique: true }),
    Index("IDX_agent_conversation_stats_external_id"),
    __metadata("design:type", String)
], AgentConversationStats.prototype, "externalId", void 0);
__decorate([
    Column(),
    Index("IDX_agent_conversation_stats_account_id"),
    __metadata("design:type", Number)
], AgentConversationStats.prototype, "accountId", void 0);
__decorate([
    Column(),
    Index("IDX_agent_conversation_stats_company_id"),
    __metadata("design:type", Number)
], AgentConversationStats.prototype, "companyId", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], AgentConversationStats.prototype, "length", void 0);
__decorate([
    Column(() => TokenUsage),
    __metadata("design:type", TokenUsage)
], AgentConversationStats.prototype, "audioTokens", void 0);
__decorate([
    Column(() => TokenUsage),
    __metadata("design:type", TokenUsage)
], AgentConversationStats.prototype, "textTokens", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], AgentConversationStats.prototype, "totalCosts", void 0);
__decorate([
    Column("text", { nullable: true, default: null }),
    __metadata("design:type", Object)
], AgentConversationStats.prototype, "agentVersion", void 0);
__decorate([
    Column("int", { nullable: true, default: null }),
    __metadata("design:type", Object)
], AgentConversationStats.prototype, "eventCount", void 0);
__decorate([
    Column("int", { nullable: true, default: null }),
    __metadata("design:type", Object)
], AgentConversationStats.prototype, "userInteractionCount", void 0);
AgentConversationStats = __decorate([
    Entity()
], AgentConversationStats);
export { AgentConversationStats };
let MetricActiveEmployeeCount = class MetricActiveEmployeeCount {
};
__decorate([
    ManyToOne(() => CompanyEntity, { eager: false, onDelete: "CASCADE" }),
    __metadata("design:type", CompanyEntity)
], MetricActiveEmployeeCount.prototype, "company", void 0);
__decorate([
    PrimaryColumn(),
    __metadata("design:type", Number)
], MetricActiveEmployeeCount.prototype, "companyId", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], MetricActiveEmployeeCount.prototype, "activeEmployeeCount", void 0);
__decorate([
    Column({ type: "int", nullable: true }),
    __metadata("design:type", Object)
], MetricActiveEmployeeCount.prototype, "activeManagerCount", void 0);
__decorate([
    Column({ type: "timestamptz", primary: true }),
    __metadata("design:type", Date)
], MetricActiveEmployeeCount.prototype, "date", void 0);
MetricActiveEmployeeCount = __decorate([
    Entity()
], MetricActiveEmployeeCount);
export { MetricActiveEmployeeCount };
let WageType = class WageType {
    constructor() {
        this.order = 0;
    }
};
__decorate([
    PrimaryColumn(),
    __metadata("design:type", Number)
], WageType.prototype, "companyId", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { eager: false, onDelete: "CASCADE" }),
    __metadata("design:type", CompanyEntity)
], WageType.prototype, "company", void 0);
__decorate([
    PrimaryColumn(),
    __metadata("design:type", String)
], WageType.prototype, "number", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], WageType.prototype, "name", void 0);
__decorate([
    Column("varchar", { nullable: true }),
    __metadata("design:type", String)
], WageType.prototype, "unit", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], WageType.prototype, "description", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], WageType.prototype, "order", void 0);
WageType = __decorate([
    Entity(),
    Unique(["companyId", "number"]),
    Unique(["companyId", "name"])
], WageType);
export { WageType };
/* TODO: ideally, the DTOs would not be used here directly, but mapped to internal types.
But that is one step better than using the external Stripe types directly. */
let BillingInfo = class BillingInfo {
    constructor() {
        this.billingMode = BillingMode.Default;
        this.hogastUnionId = null;
        this.hogastMemberId = null;
        this.customer = null;
        this.paymentMethods = [];
        this.invoices = [];
        /** Minimum number of employees billed per period, regardless of actual headcount.
         * Readable via the API but not writable — adjustments are made directly in the database. */
        this.minNumOfBillableEmployees = 10;
    }
    get info() {
        return {
            name: this.customer?.name || "",
            email: this.customer?.email || "",
            phone: this.customer?.phone || "",
            comments: this.customer?.description || "",
            addressLine1: this.customer?.address?.line1 || "",
            addressLine2: this.customer?.address?.line2 || "",
            postalCode: this.customer?.address?.postal_code || "",
            city: this.customer?.address?.city || "",
            vatId: this.customer?.tax_ids?.data?.[0]?.value || "",
            billingMode: this.billingMode,
            hogastUnionId: this.hogastUnionId,
            hogastMemberId: this.hogastMemberId,
            numberOfEmployees: this.numberOfEmployees,
        };
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], BillingInfo.prototype, "id", void 0);
__decorate([
    Column("varchar", { default: BillingMode.Default }),
    __metadata("design:type", String)
], BillingInfo.prototype, "billingMode", void 0);
__decorate([
    Column("text", { nullable: true }),
    __metadata("design:type", Object)
], BillingInfo.prototype, "hogastUnionId", void 0);
__decorate([
    Column("text", { nullable: true }),
    __metadata("design:type", Object)
], BillingInfo.prototype, "hogastMemberId", void 0);
__decorate([
    PrimaryColumn(),
    __metadata("design:type", String)
], BillingInfo.prototype, "customerId", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], BillingInfo.prototype, "customer", void 0);
__decorate([
    Column("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], BillingInfo.prototype, "paymentMethods", void 0);
__decorate([
    Type(() => Invoice),
    Column("jsonb", {
        default: "[]",
        transformer: {
            to: (invoices) => {
                if (!invoices)
                    return [];
                return invoices.map(({ raw, creditNotes }) => ({ raw, creditNotes }));
            },
            from: (rawInvoices) => {
                if (!rawInvoices)
                    return [];
                return rawInvoices.map(({ raw, creditNotes }) => new Invoice(raw, undefined, creditNotes));
            },
        },
    }),
    __metadata("design:type", Array)
], BillingInfo.prototype, "invoices", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Number)
], BillingInfo.prototype, "numberOfEmployees", void 0);
__decorate([
    Column({ default: 10 }),
    __metadata("design:type", Number)
], BillingInfo.prototype, "minNumOfBillableEmployees", void 0);
BillingInfo = __decorate([
    Entity()
], BillingInfo);
export { BillingInfo };
export class EmailTemplate {
    constructor(init = {}) {
        Object.assign(this, init);
    }
}
__decorate([
    Column({ length: 255, nullable: true }),
    __metadata("design:type", String)
], EmailTemplate.prototype, "title", void 0);
__decorate([
    Column("text", { nullable: true }),
    __metadata("design:type", String)
], EmailTemplate.prototype, "body", void 0);
__decorate([
    Column({ length: 255, nullable: true }),
    __metadata("design:type", String)
], EmailTemplate.prototype, "replyTo", void 0);
let TimeLogDevice = class TimeLogDevice {
    constructor(init = {}) {
        this.description = "";
        this.connectionCode = "";
        this.displaySchedule = true;
        this.displayUpcoming = true;
        this.displayActive = true;
        this.colorScheme = "system";
        this.legacy = false;
        this.appVersion = null;
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryColumn(),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "id", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE" }),
    Type(() => CompanyEntity),
    __metadata("design:type", CompanyEntity)
], TimeLogDevice.prototype, "company", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], TimeLogDevice.prototype, "companyId", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "clientId", void 0);
__decorate([
    ManyToOne(() => APIClient, { onDelete: "CASCADE", nullable: true }),
    __metadata("design:type", APIClient)
], TimeLogDevice.prototype, "client", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "authTokenId", void 0);
__decorate([
    ManyToOne(() => APIAuthToken, { onDelete: "SET NULL", nullable: true }),
    __metadata("design:type", APIAuthToken)
], TimeLogDevice.prototype, "authToken", void 0);
__decorate([
    Column("jsonb", { default: [] }),
    __metadata("design:type", Array)
], TimeLogDevice.prototype, "filters", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "description", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "image", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "connectionCode", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "type", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "vendor", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "model", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "userAgent", void 0);
__decorate([
    Column({ nullable: true }),
    Type(() => Date),
    __metadata("design:type", Date)
], TimeLogDevice.prototype, "lastActive", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], TimeLogDevice.prototype, "displaySchedule", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], TimeLogDevice.prototype, "displayUpcoming", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], TimeLogDevice.prototype, "displayActive", void 0);
__decorate([
    Column("varchar", { default: "system" }),
    __metadata("design:type", String)
], TimeLogDevice.prototype, "colorScheme", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeLogDevice.prototype, "legacy", void 0);
__decorate([
    Column("text", { nullable: true }),
    __metadata("design:type", Object)
], TimeLogDevice.prototype, "appVersion", void 0);
TimeLogDevice = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], TimeLogDevice);
export { TimeLogDevice };
let TimeLogEvent = class TimeLogEvent {
    constructor(init = {}) {
        this.source = "terminal";
        this.status = "pending";
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryColumn(),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "id", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "action", void 0);
__decorate([
    Column("varchar", { default: "terminal" }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "source", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "deviceId", void 0);
__decorate([
    ManyToOne(() => TimeLogDevice, { onDelete: "SET NULL", nullable: true }),
    __metadata("design:type", TimeLogDevice)
], TimeLogEvent.prototype, "device", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], TimeLogEvent.prototype, "employeeId", void 0);
__decorate([
    ManyToOne(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], TimeLogEvent.prototype, "employee", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Number)
], TimeLogEvent.prototype, "positionId", void 0);
__decorate([
    ManyToOne(() => Position, { onDelete: "CASCADE", nullable: true }),
    __metadata("design:type", Position)
], TimeLogEvent.prototype, "position", void 0);
__decorate([
    Index("IDX_time_log_event_time_entry_id", { where: '"timeEntryId" IS NOT NULL' }),
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "timeEntryId", void 0);
__decorate([
    ManyToOne(() => TimeEntry, { onDelete: "CASCADE", nullable: true }),
    __metadata("design:type", TimeEntry)
], TimeLogEvent.prototype, "timeEntry", void 0);
__decorate([
    Column(),
    Type(() => Date),
    __metadata("design:type", Date)
], TimeLogEvent.prototype, "time", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "status", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "rejectedReason", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], TimeLogEvent.prototype, "location", void 0);
__decorate([
    Column("varchar", { nullable: true }),
    __metadata("design:type", Object)
], TimeLogEvent.prototype, "image", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], TimeLogEvent.prototype, "comment", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], TimeLogEvent.prototype, "meals", void 0);
TimeLogEvent = __decorate([
    Entity(),
    Index("IDX_time_log_event_employee_id_time", ["employeeId", "time"], { unique: false }),
    __metadata("design:paramtypes", [Object])
], TimeLogEvent);
export { TimeLogEvent };
let Note = class Note {
    constructor(init = {}) {
        this.content = "";
        this.type = "textNote";
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Note.prototype, "id", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], Note.prototype, "employeeId", void 0);
__decorate([
    ManyToOne(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Note.prototype, "employee", void 0);
__decorate([
    Column("text"),
    __metadata("design:type", String)
], Note.prototype, "content", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], Note.prototype, "type", void 0);
__decorate([
    CreateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], Note.prototype, "created", void 0);
__decorate([
    UpdateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], Note.prototype, "updated", void 0);
Note = __decorate([
    Entity(),
    Unique(["employeeId", "type"]),
    __metadata("design:paramtypes", [Object])
], Note);
export { Note };
//# sourceMappingURL=entities.js.map